import React, { useEffect } from "react";
import ScreenSaver from "@pages/Login/common/ScreenSaver";
import { useTranslation } from "react-i18next";
import { cleanAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";
import { useErrorNotification } from "@common/components/Notification";
import { useRelayState } from "../hook";

const LogoutSuccess = () => {
  const dispatchError = useErrorNotification();
  const { t } = useTranslation();
  const navigateToRelayState = useRelayState();

  const clean = async () => {
    try {
      cleanAuthenticatedUser();
      navigateToRelayState();
    } catch (e) {
      // Might want to handle that in an other way.
      dispatchError(e, { withDetails: true, toast: false });
    }
  };
  useEffect(() => {
    clean();
  }, []);

  return <ScreenSaver pulsating text={t("Logging out, please wait...")} />;
};

export default LogoutSuccess;
